export default __webpack_public_path__ + "static/media/AutoGuide.d53a9d7f.svg";